import { ITokenModel } from "models/Login/token.model";
import { useAppSelector } from "redux/hooks";
import { selectUser } from "redux/slices/LoginSlice";
import { selectAuthSuccessAccessToken } from "redux/slices/MerchantSwitchSlice";
import { selectOtpAccessToken } from "redux/slices/OtpSlice";

export const TokenInclude = (): ITokenModel => {
  const loginUser = useAppSelector(selectUser);
  const accessTokenOtp = useAppSelector(
    (state) => state.otp.userOtp?.access_token
  );
  const selectAccessTokenOtp = useAppSelector(selectOtpAccessToken);
  const accessTokenAuthSuccess = useAppSelector(selectAuthSuccessAccessToken);
  const { merchantAuthSuccess } = useAppSelector(
    (state) => state.merchantSwitch
  );

  const token: ITokenModel = {
    TokenSessionId: (loginUser?.TokenSessionId || loginUser?.tokenSessionID)!,
    access_token: (accessTokenOtp ||
      selectAccessTokenOtp ||
      accessTokenAuthSuccess ||
      merchantAuthSuccess?.access_token)!,
  };
  return token;
};
